
import {  Center, Space, Text } from '@mantine/core'
import { DateTime } from 'luxon'
import { GetServerSideProps } from 'next'
import Head from 'next/head'
import Link from 'next/link'
import EmailSignupBanner from '../../components/EmailSignupBanner'
import { MenuId } from '../../components/Header'
import Layout from '../../components/Layout'
import { VideoList } from '../../components/Video'
import { getJWTTokenFromUser, getPlayLists, getUserInformation } from '../../lib/data'
import { PlayList, Video } from '../../lib/definitions'
import { useAuth as useClerkAuth } from '@clerk/nextjs'
import { getClerkHeader } from '../../lib/common'

import { getAuth } from '@clerk/nextjs/server';

type Data = {
  videos : Video[],
  dateProcessed: string,
  playlist: PlayList
    }


export default function Videos({data} : {data: Data})
{
  
    const {isSignedIn: loggedIn} = useClerkAuth();

    return(

      <Layout menuId={MenuId.online} hidePopUp={true}>

      <Head>
          <title>{data.playlist.description}</title>
          <meta name="description" content={data.playlist.longDescription}/>
      </Head>
      <div>
      <h1>{data.playlist.description}</h1>
    <Text ta='center'>{data.playlist.longDescription}</Text>
    {!loggedIn && <Text> To access them, <Link href='/subscription'>sign up for a subscription</Link>.</Text>}
    
      <div>
        <VideoList videos={data.videos} dateProcessed={data.dateProcessed}/>
     
      </div>

      <Center>
      <Text fw='bold'>Not found exactly what you want? Try <Link href='/playlists'>looking at our other playlists</Link>, or use our <Link href='/new-video-search'>video search</Link> to search hundreds of videos by technique, subject matter, materials, and more.</Text>
      </Center>
      </div>
      <Space h="lg" />
      <EmailSignupBanner/>
    </Layout>
      );    

}



export const getServerSideProps : GetServerSideProps = async (context)=>
{
    
    const slug = context.params?.playlist as string;
    
    const { getToken } = getAuth(context.req);
    const clerkToken = await getToken();

    if (!slug)
    {
      return {
        notFound: true
      }
    }
    let user = await getUserInformation(context.req);
    let dt = DateTime.now().toUTC().toISO();
    
    let token;

    if (user.subscribed)
    {
        token = await getJWTTokenFromUser(user);
    }

    let options = { 
        method: 'GET', cache: "no-store" as RequestCache,
        headers: {
          ... token?{'auth-token': token}:{}, 
          ...getClerkHeader(clerkToken)} as HeadersInit
        };


    let playlists = await getPlayLists();

    let playlist = playlists.get(slug);
    if (!playlist)
    {
      return {notFound:true};
    }

    let url = process.env.ADMIN_ROUTE + '/videosincategory?id=' + playlist.id;

    let at2 =  await fetch(url, options);
    let vids = ((await at2.json()).videos) as Video [];


    return {
      props: {
        data: 
        { 
          videos:vids,
          dateProcessed: dt,
          playlist: playlist
        }
      }
  }
  

}